export default __webpack_public_path__ + "static/media/Audi_EtronGT_Car_Lora_Thumb.19395433.jpg";